import BaseModel from "~/models/BaseModel";

class SampleTemplateModel extends BaseModel {}

export default SampleTemplateModel;
